export default __webpack_public_path__ + "static/media/laba-rugi.a9aa84eb.png";